/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { TranslateModule } from './../../translate/src/translate.module';
import { PagingComponent } from './paging/paging.component';
import { DateTimeComponent } from './datetime/datetime.component';
import { InaxTranslateService } from './../../translate/src/translate';
import { CommonUiResourceManager } from './resources/resource.service';
import { DisablerOverlayComponent } from './disablerOverlay/disablerOverlay.component';
import { InViewDirective } from './inView/inView.directive';
import { ModalComponent } from './modal/modal.component';
import { ModalTestComponent } from './modalTest/modalTest.component';
import { PanelExpanderDirective } from './expandablePanel/panelExpanderDirective/panelExpander.directive';
import { ExpandablePanelComponent } from './expandablePanel/expandablePanelComponent/expandablePanel.component';
import { PinButtonComponent } from './expandablePanel/pinButtonComponent/pinButton.component';
import { StandardPanelExpanderComponent } from './expandablePanel/standardPanelExpanderComponent/standardPanelExpander.component';


@NgModule({
    imports:
    [
        //Modules
        BrowserModule,
        FormsModule,
        HttpModule,
        TranslateModule
    ],
    exports:
    [
        PagingComponent,
        DateTimeComponent,
        DisablerOverlayComponent,
        InViewDirective,
        PanelExpanderDirective,
        ExpandablePanelComponent,
        ModalComponent,
        ModalTestComponent,
        PinButtonComponent,
        StandardPanelExpanderComponent
    ],
    declarations:
    [
        //Components
        PagingComponent,
        DateTimeComponent,
        DisablerOverlayComponent,
        ModalComponent,
        ModalTestComponent,
        ExpandablePanelComponent,
        PinButtonComponent,
        StandardPanelExpanderComponent,
        //Directives
        InViewDirective,
        PanelExpanderDirective
    ],
    providers:
    [
        CommonUiResourceManager, { provide: 'Window', useValue: window }
    ],
    bootstrap: []
})

export class CommonUiModule { 
    //Resource manager adds the translations to the translationservice
    constructor(private _resourceManager: CommonUiResourceManager ) {}
}